import { useWindowSize } from "../utils/hooks";

export default function Nothing() {
	useWindowSize();
	return <></>;
}
